import { motion } from 'framer-motion';
import { ArrowLeft, ArrowRight } from 'lucide-react';

export default function TraceStep({ step, index, total, value, intensity, onChange, onIntensity, onBack, onNext }) {
  const canNext = value.trim().length > 0;
  return (
    <motion.div key={step.key} initial={{ opacity: 0, x: 24 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: -24 }} transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }} data-testid={`trace-step-${step.key}`}>
      <div className="flex items-center justify-between">
        <p className="font-mono-precision text-[10px] uppercase tracking-[0.3em] text-cyan-300">Step {index + 1} of {total} · {step.stage}</p>
        <p className="font-mono-precision text-[10px] tracking-[0.2em] text-slate-600">tracing backward</p>
      </div>
      <h2 className="mt-5 font-celestial text-2xl sm:text-3xl lg:text-4xl text-slate-100 leading-tight">{step.title}</h2>
      <p className="mt-4 text-base md:text-lg text-slate-300 leading-relaxed">{step.prompt}</p>
      <p className="mt-2 text-sm text-slate-500">{step.hint}</p>

      <textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={step.placeholder}
        rows={4}
        autoFocus
        className="mt-6 w-full rounded-2xl border border-white/10 bg-black/40 px-5 py-4 text-base text-slate-100 placeholder:text-slate-600 outline-none focus:border-cyan-400/60 transition-colors resize-none"
        data-lenis-prevent
        data-testid={`trace-input-${step.key}`}
      />

      {step.intensity && (
        <div className="mt-5" data-testid="trace-intensity">
          <div className="flex items-center justify-between font-mono-precision text-[10px] uppercase tracking-[0.25em] text-slate-500">
            <span>Faint</span><span className="text-cyan-300">{intensity}/10</span><span>Overwhelming</span>
          </div>
          <input type="range" min={1} max={10} value={intensity} onChange={(e) => onIntensity(Number(e.target.value))} className="mt-3 w-full accent-cyan-400" data-testid="trace-intensity-slider" />
        </div>
      )}

      <div className="mt-8 flex items-center justify-between gap-4">
        <button onClick={onBack} className="inline-flex items-center gap-2 font-mono-precision text-[10px] uppercase tracking-[0.25em] text-slate-500 hover:text-slate-200 transition-colors py-3" data-testid="trace-back-btn"><ArrowLeft size={13} /> Back</button>
        <button onClick={onNext} disabled={!canNext} className="inline-flex items-center gap-2 font-mono-precision text-[11px] uppercase tracking-[0.25em] px-6 py-3 rounded-full bg-cyan-400 hover:bg-cyan-300 text-[#02040a] disabled:opacity-30 transition-colors" data-testid="trace-next-btn">
          {index === total - 1 ? 'See the trace' : 'Next'} <ArrowRight size={13} />
        </button>
      </div>
    </motion.div>
  );
}
